// What an accept answered when it was words rather than a plain success
// (failures.js acceptOutcome): the coach is updating the plan (a calm line
// with a spinner; a new card will replace this one), or kept the current
// plan (the coach's words, no error colour). Never an error banner.
// Mirrors the mobile app's components/v2/ProposalStatus.tsx.
import React from 'react';
import { Info, Loader2 } from 'lucide-react';

export default function ProposalStatus({ outcome }) {
  if (!outcome || (outcome.status !== 'updating' && outcome.status !== 'kept_current')) return null;
  const updating = outcome.status === 'updating';
  return (
    <p className="m-0 flex items-start gap-1.5 rounded-chip border border-border-subtle bg-bg-surface px-3 py-2.5 type-body-small text-text-secondary" role="status">
      {updating
        ? <Loader2 size={13} className="mt-px shrink-0 animate-spin text-accent-default" />
        : <Info size={13} className="mt-px shrink-0 text-text-tertiary" />}
      <span>{outcome.message}</span>
    </p>
  );
}
